import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M18.75 1.25v7.5l-7.5-7.5z',
    'M10.117 7.201l5.303-5.303 2.652 2.652-5.303 5.303-2.652-2.652zM1.25 18.75v-7.5l7.5 7.5z',
    'M9.883 12.799L4.58 18.102 1.928 15.45l5.303-5.303 2.652 2.652z',
  ],
  height: 20,
  width: 20,
});
